import YazilarService from "../../../services/YazilarService";

export default {
  namespaced: true,
  state: () => ({
    yaziListesi: [],
    yaziSayisi: 0,
  }),
  mutations: {
    setYaziListesi: (state, data) => {
      state.yaziListesi = data;
    },
    setYaziSayisi: (state, data) => {
      state.yaziSayisi = data;
    },
  },
  actions: {
    getYaziListesi: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        YazilarService.yaziListesi(data)
          .then((res) => {
            if (res.status === 200) {
              commit("setYaziListesi", res.data.list);
              commit("setYaziSayisi", res.data.count);
            }
            resolve(res);
          })
          .catch((err) => reject(err));
      });
    },
    yaziAra: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        YazilarService.yaziAra(data)
          .then((res) => {
            if (res.status === 200) {
              commit("setYaziListesi", res.data.list);
              commit("setYaziSayisi", res.data.count);
            }
            resolve(res);
          })
          .catch((err) => reject(err));
      });
    },
  },
};
